<template>
    <div class="bottom_pagin">
        <el-pagination
                class="el_pagin"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="size_list"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                :current-page="page"
                :page-size="pageSize"
                :total="total">
        </el-pagination>
    </div>
</template>

<script>
    import {mapMutations} from 'vuex'
    import {clone} from "@/utils/utils";

    export default {
        name: "pageView",
        props: [
            'currentPage',
            'pageSize',
            'total',
        ],
        data() {
            return {
                page: 1,
                size: 0,
                tot: 0,

                size_list: [10, 20, 30, 40, 50],
            }
        },
        watch: {
            currentPage() {
                this.page = Number(clone(this.currentPage))
            },
            pageSize() {
                this.size = Number(clone(this.pageSize))
            },
            total() {
                this.tot = Number(clone(this.total))
            },
        },
        mounted() {

        },
        methods: {
            handleCurrentChange(v) {
                this.$emit('getTableList', v)
            },
            handleSizeChange(v) {
                console.log(v, '56');
                this.$emit('handleSizeChange', v)
            },
        }
    }
</script>

<style scoped lang="scss">
    .bottom_pagin {
        /*background: #fff;*/
        width: 100%;
        .el_pagin {
            justify-content: center;
        }
    }
</style>